import React, { useEffect } from "react"
import { Card, CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import { SwitchToggle } from "../../../../../../component/index.jsx"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers/index.js"
import { ICON_CONSTANTS } from "../../../../../../constants/ImageConstants.js"
import { useDispatch, useSelector } from "react-redux"
import { clearMasterBaseDetail, getMasterBaseDetail } from "../../../../../../redux/actions/MasterDataAction.jsx"
import { useTranslation } from "react-i18next"
import { BaseMap } from "../component/BaseMap.jsx"
import { Skeleton } from "@material-ui/lab"
import { stringFormatting } from "../../../../../helpers/TextHelper.js"

export const MasterBaseTabDetail = ({ id }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { MasterData, General } = useSelector((state) => state)
  useEffect(() => {
    if (id) {
      dispatch(getMasterBaseDetail(id))
    }
    return () => {
      dispatch(clearMasterBaseDetail())
    }
  }, [id])

  const detailSection = ({ title, content }) => {
    return (
      <div className={"d-flex flex-column my-5"} style={{ gap: 5 }}>
        <span className={"text-neutral-gray"}>{title}</span>
        <span className={"font-size-lg"}>{content}</span>
      </div>
    )
  }

  if (General?.loading) {
    return (
      <>
        <Skeleton height={128} />
        <Skeleton height={256} />
      </>
    )
  }

  return (
    <>
      <Card>
        <CardBody className={"d-flex justify-content-between align-items-center flex-wrap py-4"}>
          <div className={"d-flex py-8"} style={{ gap: 16 }}>
            <SVG src={toAbsoluteUrl(ICON_CONSTANTS.ACTIVITY_ICONS.BASECAMP)} />
            <div className={"d-flex flex-column justify-content-center flex-wrap"}>
              <h3 className={"font-weight-bolder"}>{stringFormatting(MasterData?.data?.code)?.toUpperCase()} <span className={"text-neutral-gray"}>({stringFormatting(MasterData?.data?.regency_name)} - {stringFormatting(MasterData?.data?.district_name)})</span></h3>
              <h6 className={"text-neutral-gray"}>{stringFormatting(MasterData?.data?.warehouse_code)?.toUpperCase()} <span className={"text-neutral-gray"}>({stringFormatting(MasterData?.data?.regency_name)} - {stringFormatting(MasterData?.data?.district_name)})</span></h6>
            </div>
          </div>
          <div className={"d-flex flex-column cursor-default"}>
            <SwitchToggle
              checked={MasterData?.data?.status}
              label={t("label_base_status")}
              withLabel={true}
              withStatusText={true}
              statusText={MasterData?.data?.status ? t("label_active") : t("label_inactive")}
              disabled={true}
              checkClassName="cursor-default"
            />
          </div>
        </CardBody>
      </Card>
      <Card>
        <CardBody className={"my-4"}>
          <span className={"font-weight-bolder font-size-h5"}>{t("label_base_information").toUpperCase()}</span>
          <div className={"d-flex justify-content-around mt-5 w-full "}>
            <div className={"flex-1"}>
              {detailSection({ title: t("label_base_name"), content: <><span>{stringFormatting(MasterData?.data?.code)}</span> <span className={"text-neutral-gray"}>({stringFormatting(MasterData?.data?.regency_name)} - {stringFormatting(MasterData?.data?.district_name)})</span></> })}
              {detailSection({ title: t("label_odoo_warehouse_id_code"), content: <><span>{stringFormatting(MasterData?.data?.warehouse_code)}</span> <span className={"text-neutral-gray"}>({stringFormatting(MasterData?.data?.regency_name)} - {stringFormatting(MasterData?.data?.district_name)})</span></> })}
              {detailSection({ title: t("label_regional"), content: stringFormatting(MasterData?.data?.regional_name) })}
              {detailSection({ title: t("label_sub_regional"), content: stringFormatting(MasterData?.data?.sub_regional_name) })}
            </div>
            <div className={"flex-1"}>
              {detailSection({ title: t("label_base_type"), content: stringFormatting(MasterData?.data?.type) })}
              {detailSection({ title: t("label_address"), content: stringFormatting(MasterData?.data?.address) + ", " + stringFormatting(MasterData?.data?.sub_district_name) + ", " + stringFormatting(MasterData?.data?.district_name) + ", " + stringFormatting(MasterData?.data?.regency_name) + ", " + stringFormatting(MasterData?.data?.province_name) })}
              {detailSection({ title: t("label_postal_code"), content: stringFormatting(MasterData?.data?.postal_code) })}
            </div>
          </div>
          <div className={"mt-4"}>
            <BaseMap
              className={"rounded rounded-lg"}
              latitude={MasterData?.data?.latitude}
              longitude={MasterData?.data?.longitude}
            />
          </div>
        </CardBody>
      </Card>
    </>
  )
}